import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import DenseMenu from './DenseMenu';
import ClientProvider from './client';
export default createDemo(import.meta.url, DenseMenu, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/menus/demos/dense/DenseMenu.tsx",
    "fileName": "DenseMenu.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Paper from '@mui/material/Paper';\nimport Divider from '@mui/material/Divider';\nimport MenuList from '@mui/material/MenuList';\nimport MenuItem from '@mui/material/MenuItem';\nimport ListItemIcon from '@mui/material/ListItemIcon';\nimport ListItemText from '@mui/material/ListItemText';\nimport Check from '@mui/icons-material/Check';\n\nexport default function DenseMenu() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Paper sx={{ width: 320 }}>\n      <MenuList dense>\n        <MenuItem>\n          <ListItemText inset>Single</ListItemText>\n        </MenuItem>\n        <MenuItem>\n          <ListItemText inset>1.15</ListItemText>\n        </MenuItem>\n        <MenuItem>\n          <ListItemText inset>Double</ListItemText>\n        </MenuItem>\n        <MenuItem>\n          <ListItemIcon>\n            <Check />\n          </ListItemIcon>\n          Custom: 1.2\n        </MenuItem>\n        <Divider />\n        <MenuItem>\n          <ListItemText>Add space before paragraph</ListItemText>\n        </MenuItem>\n        <MenuItem>\n          <ListItemText>Add space after paragraph</ListItemText>\n        </MenuItem>\n        <Divider />\n        <MenuItem>\n          <ListItemText>Custom spacing…</ListItemText>\n        </MenuItem>\n      </MenuList>\n    </Paper>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 42,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Paper from '@mui/material/Paper';\nimport Divider from '@mui/material/Divider';\nimport MenuList from '@mui/material/MenuList';\nimport MenuItem from '@mui/material/MenuItem';\nimport ListItemIcon from '@mui/material/ListItemIcon';\nimport ListItemText from '@mui/material/ListItemText';\nimport Check from '@mui/icons-material/Check';\n\nexport default function DenseMenu() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <Paper sx={{ width: 320 }}>\n      <MenuList dense>\n        <MenuItem>\n          <ListItemText inset>Single</ListItemText>\n        </MenuItem>\n        <MenuItem>\n          <ListItemText inset>1.15</ListItemText>\n        </MenuItem>\n        <MenuItem>\n          <ListItemText inset>Double</ListItemText>\n        </MenuItem>\n        <MenuItem>\n          <ListItemIcon>\n            <Check />\n          </ListItemIcon>\n          Custom: 1.2\n        </MenuItem>\n        <Divider />\n        <MenuItem>\n          <ListItemText>Add space before paragraph</ListItemText>\n        </MenuItem>\n        <MenuItem>\n          <ListItemText>Add space after paragraph</ListItemText>\n        </MenuItem>\n        <Divider />\n        <MenuItem>\n          <ListItemText>Custom spacing…</ListItemText>\n        </MenuItem>\n      </MenuList>\n    </Paper>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 42,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Paper",
      "@mui/material/Divider",
      "@mui/material/MenuList",
      "@mui/material/MenuItem",
      "@mui/material/ListItemIcon",
      "@mui/material/ListItemText",
      "@mui/icons-material/Check"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
